import gql from 'graphql-tag'

const deleteCustomer = gql`
  mutation ($id: Float!, $workspace_id: Float!) {
    deleteCustomer(id: $id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`

export default deleteCustomer
